<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="none"
  ><g
    stroke="currentColor"
    stroke-linecap="round"
    stroke-linejoin="round"
    stroke-width="1.75"
    clip-path="url(#a)"
  ><path d="m.948.945 22.103 22.11M6.97 10.575H5.738c-1.204 0-2.795-.91-4.525-3.394-.323 2.484.358 4.204 1.402 5.132v10.732l2.998.008 1.738-5.296h6.353l1.402 5.288h3.219v-1.23M10.692 10.58a1.86 1.86 0 0 0 1.563-.916c1.497-3.008.459-8.344 4.505-8.224v2.63s4.136 1.322 6.076 1.965c0 0 .65 4.77-4.482 4.77.002 4.663-.001 2.824-.001 7.484" /></g><defs><clipPath id="a"><path
    fill="none"
    d="M0 0h24v24H0z"
  /></clipPath></defs></svg>
</template>
